(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('stat-technicien', {
            parent: 'technicienMenu',
            url: '/stat-technicien?dateFrom&dateTo&technicien&comparaisonStatus',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.statTechnicien.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stat-technicien/stat-techniciens.html',
                    controller: 'StatTechnicienController',
                    controllerAs: 'vm'
                }
            },
            params: {
                dateFrom: null,
                dateTo: null,
                technicien: null,
                comparaisonStatus: []
            },
            resolve: {
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        dateFrom: $stateParams.dateFrom,
                        dateTo: $stateParams.dateTo,
                        technicien: $stateParams.technicien,
                        comparaisonStatus: Array.isArray($stateParams.comparaisonStatus) ? $stateParams.comparaisonStatus: [$stateParams.comparaisonStatus]
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('intervention');
                	$translatePartialLoader.addPart('statTechnicien');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('stat-technicien-detail', {
            parent: 'stat-technicien',
            url: '/stat-technicien/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.statTechnicien.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/stat-technicien/stat-technicien-detail.html',
                    controller: 'StatTechnicienDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('statTechnicien');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'StatTechnicien', function($stateParams, StatTechnicien) {
                    return StatTechnicien.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'stat-technicien',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('stat-technicien-detail.edit', {
            parent: 'stat-technicien-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stat-technicien/stat-technicien-dialog.html',
                    controller: 'StatTechnicienDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatTechnicien', function(StatTechnicien) {
                            return StatTechnicien.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('stat-technicien.new', {
            parent: 'stat-technicien',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stat-technicien/stat-technicien-dialog.html',
                    controller: 'StatTechnicienDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                technicien: null,
                                code: null,
                                yearMonth: null,
                                qty: null,
                                price: null,
                                qtyBonus: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('stat-technicien', null, { reload: 'stat-technicien' });
                }, function() {
                    $state.go('stat-technicien');
                });
            }]
        })
        .state('stat-technicien.edit', {
            parent: 'stat-technicien',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stat-technicien/stat-technicien-dialog.html',
                    controller: 'StatTechnicienDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['StatTechnicien', function(StatTechnicien) {
                            return StatTechnicien.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('stat-technicien', null, { reload: 'stat-technicien' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('stat-technicien.delete', {
            parent: 'stat-technicien',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/stat-technicien/stat-technicien-delete-dialog.html',
                    controller: 'StatTechnicienDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['StatTechnicien', function(StatTechnicien) {
                            return StatTechnicien.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('stat-technicien', null, { reload: 'stat-technicien' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
